module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vuePerfectLayoutTest",
    attrs: {
      "name": "vue-perfect-layout"
    }
  }, [_c('div', {
    attrs: {
      "id": "gallery"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6a4559af!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vuePerfectLayoutTest/components/index.vue
// module id = 586
// module chunks = 2